import { Money } from '@principle-theorem/accounting';
import {
  IContextBuilder,
  IInvoiceScopeData,
  IInvoiceTemplateContext,
} from '@principle-theorem/principle-core/interfaces';
import {
  CALENDAR_TIME_FORMAT,
  DAY_MONTH_YEAR_FORMAT,
  TIME_FORMAT,
  toMoment,
  toMomentTz,
} from '@principle-theorem/shared';
import { Invoice } from '../../models/invoice/invoice';
import { PatientContextBuilder } from './patient-context';
import { PracticeContextBuilder } from './practice-context';

export class InvoiceContextBuilder
  implements IContextBuilder<IInvoiceTemplateContext>
{
  private _patientContextBuilder: PatientContextBuilder;
  private _practiceContextBuilder: PracticeContextBuilder;

  constructor(private _data: IInvoiceScopeData) {
    this._patientContextBuilder = new PatientContextBuilder(this._data);
    this._practiceContextBuilder = new PracticeContextBuilder(this._data);
  }

  build(): IInvoiceTemplateContext {
    const balance = Invoice.balance(
      this._data.invoice,
      this._data.transactions
    );

    const dueDate = this._data.invoice.due
      ? toMomentTz(
          this._data.invoice.due,
          this._data.practice.settings.timezone
        ).format(DAY_MONTH_YEAR_FORMAT)
      : '';

    return {
      ...this._patientContextBuilder.build(),
      ...this._practiceContextBuilder.build(),
      invoiceLink: this._data.invoiceLink,
      invoiceCreatedAt: toMoment(this._data.invoice.createdAt).calendar(
        undefined,
        CALENDAR_TIME_FORMAT
      ),
      invoiceCreatedAtDate: toMoment(this._data.invoice.createdAt).format(
        DAY_MONTH_YEAR_FORMAT
      ),
      invoiceCreatedAtTime: toMoment(this._data.invoice.createdAt).format(
        TIME_FORMAT
      ),
      invoiceReference: this._data.invoice.reference,
      invoicePracticeName: this._data.invoice.practice.name,
      invoiceAmount: `$${Money.amount(
        Invoice.total(this._data.invoice)
      ).toFixed(2)}`,
      invoiceBalance: `$${Money.amount(balance).toFixed(2)}`,
      invoiceDueDate: dueDate,
    };
  }
}
